import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Network from "../components/Network";
import Conditions from "../components/Conditions";
import Security from "../components/Security";
import WhyUs from "../components/WhyUs";
import Wealth from "../components/Wealth";
import Advisory from "../components/Advisory";
import Process from "../components/Process";
import Corporate from "../components/Corporate";
import Strategies from "../components/Strategies";
import Steps from "../components/Steps";
import Fees from "../components/Fees";
import Calculator from "../components/Calculator";
import Team from "../components/Team";
import Testimonials from "../components/Testimonials";
import ContactForm from "../components/ContactForm";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";
import AccountModal from "../components/AccountModal";

export default function Landing() {
  const [modalOpen, setModalOpen] = useState(false);

  const scrollToContact = useCallback(() => {
    document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  const openAccount = useCallback(() => setModalOpen(true), []);

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 250);
    }
  }, [location]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = document.querySelectorAll(".reveal");
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Header onOpenAccount={openAccount} />
      <Hero onOpenAccount={openAccount} />
      <Network />
      <Conditions onOpenAccount={openAccount} />
      <Security />
      <WhyUs />
      <Wealth onContact={scrollToContact} />
      <Advisory onContact={scrollToContact} />
      <Process />
      <Corporate onContact={scrollToContact} />
      <Strategies onContact={scrollToContact} />
      <Steps />
      <Fees />
      <Calculator onOpenAccount={openAccount} />
      <Team />
      <Testimonials />
      <ContactForm />
      <FinalCTA onOpenAccount={openAccount} />
      <Footer />
      <AccountModal open={modalOpen} onOpenChange={setModalOpen} />
    </>
  );
}
